import React from "react";
import { cn } from "../../services/Utils";
import { InputField } from "../InputField";
import * as LabelPrimitive from "@radix-ui/react-label";

export const Label = ({ className, ...props }) => {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "text-charcoal-700 flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
};

export const TextField = ({
  label,
  name,
  type = "text",
  className,
  labelClassName,
  inputClassName,
  placeholder,
  value,
  onChange,
  required,
  disabled,
  children,
  id,
  ...props
}) => {
  return (
    <div className={cn("w-full rounded-2xl", className)}>
      {label && (
        <Label htmlFor={id || name} className={labelClassName}>
          {label}
        </Label>
      )}
      <InputField
        id={id || name}
        name={name}
        type={type}
        className={cn(label && "mt-4", "focus:ring-gray-300", inputClassName)}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        {...props}
      />
      {children}
    </div>
  );
};
